<template>
  <p
    v-if="delivery && delivery.status === 'paused'"
    role="status"
    class="px-6 py-3 text-sm text-red-500"
    data-cy="autoplug-delivery-warning"
  >
    {{ message }}
  </p>
</template>

<script>
  export default {
    props: { delivery: { type: Object, default: null } },
    computed: {
      message() {
        if (this.delivery.reason === 'outcome_unknown') {
          return 'Autoplug paused: X did not confirm whether your reply was published. Check the original post on X before replying manually.';
        }
        if (this.delivery.reason === 'reconnect_x') {
          return 'Autoplug paused: reconnect your X account before posting your reply manually.';
        }
        return 'Autoplug paused because X rejected the request. Check the original post on X before replying manually.';
      },
    },
  };
</script>
